import { Component, Inject, OnInit } from '@angular/core';
import { ApiRequestService, MAT_ICON, TOAST_STATE, ToastmessageService, TranslationService, HttpError } from '@prekog/pw-common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { GetProductsResponse } from '../../products/getproductsresponse';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Material } from '../../products/material';
import { GetCategoryRequest } from './getcategoryrequest';
import { Category } from '../category';
import { UpdateCategoryRequest } from './updatecategoryrequest';
import { CreateCategoryProductRequest } from '../addcategory/createcategoryproductrequest';
import { DeleteCategoryProductRequest } from './deletecategoryproductrequest';
import { DeleteCategoryProductResponse } from './deletecategoryproductresponse';
import { GetProductsForCategoryRequest } from './getProductsForCategoryRequest';
import { GetProductsForCategoryResponse } from './getproductsforcategoryresponse';
import { UpdateCategoryResponse } from './updatecategoryresponse';
import { CategoryProduct } from '../addcategory/categoryproduct';
import { CreateCategoryProductResponse } from '../addcategory/createcategoryproductresponse';
import { GetCategoryResponse } from './getcategoryresponse';

@Component({
    selector: 'app-updatecategory',
    templateUrl: './updatecategory.component.html',
    styleUrls: ['../../packages/updatepackage/updatepackage.component.scss']
})
export class UpdatecategoryComponent implements OnInit {

    getCategoryRequest: GetCategoryRequest = {};

    storeBaseUrl = '';

    getCategoryUrl = '/admin/getcategory';

    category: Category = {};

    updateCategoryUrl = '/admin/updatecategory';

    categoryForm?: FormGroup;

    updateCategoryRequest: UpdateCategoryRequest = {};

    getProductsForCategoryRequest: GetProductsForCategoryRequest = {};

    updateableProducts: Material[] = [];

    products: Material[] = [];

    storeExistingProductsURI = '/store/get-products';


    createCategoryProductUrl = '/admin/createcategoryproduct';

    deleteCategoryProductUrl = '/admin/deletecategoryproduct';

    getProductsForCategoryUrl = '/admin/get-categoryproduct';

    filteredBooks: Material[] = [];

    createCategoryProductRequest: CreateCategoryProductRequest = {};

    deleteCategoryProductRequest: DeleteCategoryProductRequest = {};

    deleteCategoryProductResponse: DeleteCategoryProductResponse = {};

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    searchText = '';

    constructor(
        private _router: Router,
        private _fb: FormBuilder,
        private _toastMessageService: ToastmessageService,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _translateService: TranslationService,
        private readonly breakpointObserver: BreakpointObserver,
        private _matDialog: MatDialog
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createCategoryForm();
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall = this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }

    addProductToCategory(product: Material) {
        const index = this.products.indexOf(product);
        this.products.splice(index, 1);
        this.updateableProducts.push(product);

    }


    deleteFromCategoryProductList(product: Material) {
        const index = this.updateableProducts.indexOf(product);
        this.updateableProducts.splice(index, 1);
        this.products.push(product);
    }


    //TODO combine it with Products changing option!
    ngOnInit(): void {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        const routerLink = lastSegmentOfUrl as string;
        const id = +routerLink;
        this.getCategoryRequest = {
            categoryId: id
        };

        this._apiRequestService
            .sendRequest<GetCategoryRequest, GetCategoryResponse>(this.storeBaseUrl, true, this.getCategoryRequest, true, this.getCategoryUrl)
            .subscribe((response) => {
                this.category = response.category!;
                this.getProductsForCategoryRequest = {
                    categoryId: this.category.id
                };
                this._apiRequestService
                    .sendRequest<GetProductsForCategoryRequest, GetProductsForCategoryResponse>(
                        this.storeBaseUrl,
                        true,
                        this.getProductsForCategoryRequest,
                        true,
                        this.getProductsForCategoryUrl
                    )
                    .pipe(
                        catchError((error: HttpErrorResponse) => {
                            return throwError(() => {
                                const httpError: HttpError = error.error as HttpError;

                                this._toastMessageService.displayToastMessage(
                                    TOAST_STATE.error,
                                    this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                                    MAT_ICON.error
                                );
                                this.dismissError();

                                this._router.navigateByUrl('/');
                            });
                        })
                    )
                    .subscribe((response) => {
                        this.updateableProducts = response.products as Material[];
                        this._apiRequestService
                            .sendRequest(this.storeBaseUrl, true, {}, true, this.storeExistingProductsURI)
                            .pipe(
                                catchError((error: HttpErrorResponse) => {
                                    return throwError(() => {
                                        const httpError: HttpError = error.error as HttpError;

                                        this._toastMessageService.displayToastMessage(
                                            TOAST_STATE.error,
                                            this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                                            MAT_ICON.error
                                        );
                                        this.dismissError();

                                        this._router.navigateByUrl('/');
                                    });
                                })
                            )
                            .subscribe((response) => {
                                const products = response as GetProductsResponse;
                                products.productList as Material[];

                                //skipping same elements with updateAbleProducts from products
                                this.products = products.productList?.filter(p => !this.updateableProducts.some(p2 => p2.routerLink === p.routerLink)) as Material[];

                                this.filteredBooks = this.products;
                                if (sessionStorage.getItem('product')) {
                                    const product = JSON.parse(sessionStorage.getItem('product') as string) as Material;
                                    const index = this.products.indexOf(product);
                                    this.products.splice(index, 1);
                                    this.updateableProducts.push(product);
                                    sessionStorage.removeItem('product');

                                }

                            });
                    });
            });
    }


    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    createCategoryForm() {
        this.categoryForm = this._fb.group({
            name: ['', [Validators.required]]

        });
    }

    collectCategoryData(category: Category) {
        category = {
            name: this.categoryForm?.controls['name'].value as string | undefined
        };

    }

    updateCategory(category: Category) {

        this.collectCategoryData(category);
        this.updateCategoryRequest = {
            category: category
        }
        this._apiRequestService
            .sendRequest<UpdateCategoryRequest, UpdateCategoryResponse>(this.storeBaseUrl, true, this.updateCategoryRequest, true, this.updateCategoryUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage), MAT_ICON.error);
                        this.dismissError();

                        this._router.navigateByUrl('/');
                    });
                })
            )
            .subscribe((response) => {
                this.updateCategoryProducts();

                this._toastMessageService.displayToastMessage(
                    TOAST_STATE.success,
                    response.message as string,
                    MAT_ICON.success
                );
                this.dismissError();
            });

    }


    updateCategoryProducts() {
        //TODO separate backend calls to different methods for clean code
        this.deleteCategoryProductRequest = {
            categoryId: this.category.id
        };
        this._apiRequestService
            .sendRequest<DeleteCategoryProductRequest, DeleteCategoryProductResponse>(
                this.storeBaseUrl,
                true,
                this.deleteCategoryProductRequest,
                true,
                this.deleteCategoryProductUrl
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(
                            TOAST_STATE.error,
                            this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                            MAT_ICON.error
                        );
                        this.dismissError();

                        this._router.navigateByUrl('/');
                    });
                })
            )
            .subscribe((responseMessage) => {
                let categoryProductList: CategoryProduct[] = [];
                this.updateableProducts.forEach((productsToCategory) => {
                    const categoryProduct: CategoryProduct = new CategoryProduct();
                    categoryProduct.product = productsToCategory;
                    categoryProduct.category = this.category;
                    categoryProductList.push(categoryProduct);
                });
                this.createCategoryProductRequest = {
                    categoryProductList: categoryProductList
                };
                this._apiRequestService
                    .sendRequest<CreateCategoryProductRequest, CreateCategoryProductResponse>(
                        this.storeBaseUrl,
                        true,
                        this.createCategoryProductRequest,
                        true,
                        this.createCategoryProductUrl
                    )
                    .pipe(
                        catchError((error: HttpErrorResponse) => {
                            return throwError(() => {
                                const httpError: HttpError = error.error as HttpError;

                                this._toastMessageService.displayToastMessage(
                                    TOAST_STATE.error,
                                    this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                                    MAT_ICON.error
                                );
                                this.dismissError();

                                this._router.navigateByUrl('/');
                            });
                        })
                    )
                    .subscribe((responseMessage) => {
                        this._toastMessageService.displayToastMessage(
                            TOAST_STATE.success,
                            responseMessage.responseMessage!,
                            MAT_ICON.success
                        );
                        this.dismissError();

                    });
            });
    }

}
